import { render, staticRenderFns } from "./Myartworks.vue?vue&type=template&id=5ca05736"
import script from "./Myartworks.vue?vue&type=script&lang=js"
export * from "./Myartworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports